import { render } from "./MailboxDeleteModal.vue?vue&type=template&id=3d6d35fc"
import script from "./MailboxDeleteModal.vue?vue&type=script&lang=js"
export * from "./MailboxDeleteModal.vue?vue&type=script&lang=js"
script.render = render

export default script